export default __webpack_public_path__ + "static/media/T.aea091ea.svg";